import { voucher } from "../repositories";

export default {
  getVoucherDetail: async (voucherCode: string) => {
    const rs = await voucher.getVoucher(voucherCode);
    if (!rs?.data) {
      return null;
    }
    return rs.data;
  },
};
